






























import Vue from "vue"
import { CreateParcelModel } from "@/model/new-parcel-model/create-parcel-model"

export interface ILimitedQuantitySpecification extends Vue {
  emitValidation(): void
  clearAll(): void
  form: {}
}

interface LimitedQuantitySpecification {
  form: any
  rules: any
}
export default Vue.extend({
  data(): LimitedQuantitySpecification {
    return {
      form: {},
      rules: {
        lqUnno: [
          {
            min: 1,
            max: 19,
            message: this.$t("new.parcel.error.hazardous.unno"),
            trigger: ["change", "blur"]
          },
          {
            type: "string",
            required: true,
            message: this.$t("new.parcel.error.hazardous.unno")
          }
        ],
        lqPgGroup: [
          {
            min: 1,
            max: 15,
            message: this.$t("new.parcel.error.hazardous.pggroup"),
            trigger: ["change", "blur"]
          },
          {
            type: "string",
            required: true,
            message: this.$t("new.parcel.error.hazardous.pggroup")
          }
        ],
        lqCCode: [
          {
            min: 1,
            max: 5,
            message: this.$t("new.parcel.error.hazardous.ccode"),
            trigger: ["change", "blur"]
          },
          {
            type: "string",
            required: true,
            message: this.$t("new.parcel.error.hazardous.ccode")
          }
        ],
        lqClass: [
          {
            min: 1,
            max: 6,
            message: this.$t("new.parcel.error.hazardous.class"),
            trigger: ["change", "blur"]
          }
        ],
        lqSubWeight: [
          {
            min: 1,
            max: 8,
            message: this.$t("new.parcel.error.hazardous.sub_weight"),
            trigger: ["change", "blur"]
          },
          {
            type: "string",
            message: this.$t("new.parcel.error.hazardous.sub_weight"),
            trigger: ["change", "blur"]
          }
        ]
      }
    }
  },
  props: {
    limitedQuantitySpecificationValidated: {
      type: Boolean,
      required: true
    },
    createParcelModel: {
      type: CreateParcelModel,
      required: true
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    emitValidation() {
      const vm = this as any
      vm.$refs.form.validate(valid => {
        this.$emit("update:limitedQuantitySpecificationValidated", valid)
      })
    },
    clearAll() {
      this.form = {}
    }
  },
  watch: {
    form: {
      handler() {
        this.emitValidation()
      },
      deep: true
    }
  },
  mounted() {
    this.emitValidation()
  }
})
